/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type AdditionalDataHolder, type BaseRequestBuilder, type Parsable, type ParsableFactory, type ParseNode, type RequestConfiguration, type RequestInformation, type RequestsMetadata, type SerializationWriter } from '@microsoft/kiota-abstractions';

/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PromotionRedemptionsGetResponse}
 */
// @ts-ignore
export function createPromotionRedemptionsGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPromotionRedemptionsGetResponse;
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPromotionRedemptionsGetResponse(promotionRedemptionsGetResponse: Partial<PromotionRedemptionsGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
export interface PromotionRedemptionsGetResponse extends AdditionalDataHolder, Parsable {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
}
/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/promotion-redemptions
 */
export interface PromotionRedemptionsRequestBuilder extends BaseRequestBuilder<PromotionRedemptionsRequestBuilder> {
    /**
     * How many orders redeemed each promotion of the campaign, keyed by promotion id; a promotion no order carries is absent. A redeemed promotion cannot be deleted from the campaign, only deactivated.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PromotionRedemptionsGetResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PromotionRedemptionsGetResponse | undefined>;
    /**
     * How many orders redeemed each promotion of the campaign, keyed by promotion id; a promotion no order carries is absent. A redeemed promotion cannot be deleted from the campaign, only deactivated.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePromotionRedemptionsGetResponse(writer: SerializationWriter, promotionRedemptionsGetResponse: Partial<PromotionRedemptionsGetResponse> | undefined | null = {}) : void {
    if (promotionRedemptionsGetResponse) {
        writer.writeAdditionalData(promotionRedemptionsGetResponse.additionalData);
    }
}
/**
 * Uri template for the request builder.
 */
export const PromotionRedemptionsRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/promotion-redemptions";
/**
 * Metadata for all the requests in the request builder.
 */
export const PromotionRedemptionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PromotionRedemptionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPromotionRedemptionsGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
